/* eslint-disable import/prefer-default-export */
export const MCCAIN_PDF_WRAPPER = 'mccain-pdf-wrapper';
